import { useToast } from "native-base";
import React from "react";
import { useDispatch } from "react-redux";
import { setDoorbellCameraId } from "../actions/AppActions";
import { ArButton } from "../argon-ui";
import { translate } from "../locales/translate";

type Props = {
  cameraId: number;
  cameraName: string;
};

const ShowCameraDoorbell = (props: Props) => {
  const { cameraId, cameraName } = props;
  const dispatch = useDispatch();
  const toast = useToast();
  return (
    <ArButton
      color="green"
      onPress={() => {
        dispatch(setDoorbellCameraId(cameraId));
      }}
    >
      {`${translate("camera.showCamera")} " ${cameraName} "`}
    </ArButton>
  );
};

export default ShowCameraDoorbell;
